
export class Dominio {

    public estadosOperacao: EstadoOperacao[];
    public tiposLogradouros: TipoLogradouro[];
    public cnaes: Cnae[];
    public municipios: Municipio[];
    public tiposOutrasGarantias: TipoOutraGarantia[];
    public naturezas: Natureza[];
    public modalidades: Modalidade[];
    public naturezasN02: NaturezaN02[];
    public complementosNaturezasN02: ComplementoNaturezaN02[];
    public indexadores: Indexador[];
    public tiposContratoFichaCobranca: TipoContratoFichaCobrancaDTO[];
    public mapaDominiosProdutos: { [parametro: string] : DominioNegocioDTO; }
}

export class Indexador {
    public id: number;
    public nome: string;
}

export class EstadoOperacao {
    public id: number;
    public nome; string;
}

export class TipoLogradouro {
    public id: number;
    public nome; string;
}

export class Cnae {
    public codigo: string;
    public nome; string;
}

export class Municipio {
    public id: string;
    public nome; string;
}

export class TipoOutraGarantia {
    public codigo: string;
    public descricao: string;
    public garantiaReal: boolean;
    public fidejussoria: boolean;
}

export class Natureza {
    public id: number;
    public nome; string;
}

export class Modalidade {
    public id: string;
    public nome; string;
}

export class NaturezaN02 {
    public codigo: string;
    public nome; string;
}

export class ComplementoNaturezaN02 {
    public codigo: string;
    public nome; string;
}

export class ProgramaBndes {
    public id: string;
    public nome; string;
}

export class TipoContratoFichaCobrancaDTO {
    public codigo: string;
    public descricao: string;
}

export class DominioNegocioDTO {
    public idNegocio: string;
    public nome: string;
}

export class TaxaAtualizacaoGarantiaDTO {
    public id: string;
    public dataInicioValidade: string;
    public dataFinalValidade: string;
    public descIndexador: string;
    public descModalidade: string;
    public taxaGarantia: string;
    public ideModalidade: number;
    public ideIndexador: number;
}